import React from 'react';
import './output.css';
import Header from './feacture/header/Header'
import Hero from "./feacture/hero/Hero";
import About from './feacture/About/About';
import Footer from './feacture/Footer/Footer';
import ContactForm from './feacture/Contact/Contact';
import "@fortawesome/fontawesome-free/css/all.css";
import FAQ from './feacture/FAQ/FAQ';
import Process from './feacture/Process/Process';
import MainProducts from './feacture/FilesView/mainProducts';
import ExtraComp from './feacture/ExtraComp/ExtraComp';
import MainSecond from './feacture/secModule/MainSecond';
import Activites from './feacture/Activites/Activites';
import PracticeVideo from './feacture/TutorialVideo/PracticeVideo';
import OtherProduct from './feacture/OtherProducts/OtherProduct';
import RightSoft from './feacture/RightSoft/RightSoft';
import OMU from './feacture/OMU/OMU';
import SecExtra from './feacture/ExtraComp/secExtra';
import AllFeatures1 from './feacture/AllFeatures/Allfeatures1';


function App() {
  
  return (
    <>
      <Header />  
      <Hero />
      {/* <AllFeatures1 /> */}
      <RightSoft />
      <Activites />
      <Process />
      <ExtraComp />
      <MainSecond />
      <MainProducts />
      <OMU />
      <OtherProduct />
      <About />
      <ContactForm />
      <FAQ />
      <PracticeVideo />
      <SecExtra />
      <Footer />
    </>
  );
}

export default App;
